import { createContext, useContext, type ReactNode } from 'react';

/**
 * Whether a value input stretches to fill the rest of its line. It does in
 * the operator and value's own row, and keeps its own width when the controls
 * flow into a row the caller lays out.
 */
const GrowingValueContext = createContext(false);

type GrowingValueProviderProps = {
  children: ReactNode;
};

/** Stretches every value input below it to the end of its line. */
export function GrowingValueProvider({ children }: GrowingValueProviderProps) {
  return <GrowingValueContext.Provider value>{children}</GrowingValueContext.Provider>;
}

/** Whether the value input should stretch to the end of its line. */
export function useIsGrowingValue(): boolean {
  return useContext(GrowingValueContext);
}
